import { get } from 'lodash';
export default function getCentreStores(centre, entry) {
  const centreId = get(centre, 'sys.id');
  if (!centreId) {
    return null;
  }
  const store = (entry.stores || get(entry, 'storesCollection.items', [])).filter(storeData => get(storeData, 'centre.sys.id') === centreId);
  return store;
}